
import { Component, Vue } from 'vue-property-decorator';
import { AmplifyEventBus } from 'aws-amplify-vue';
import auth from '@/services/auth';
import JobBlissLogo from '@/components/icons/jobBlissLogo.vue';
import GET_USER from '@/apollo/main/GetUser.gql';

import UiButton from '@/components/button/ui-button.vue';
import AuthFormLink from '@/components/auth/AuthFormLinkNew.vue';
import AuthCard from '@/components/auth/AuthCard.vue';
import FormGroup from '@/components/form/FormGroupNew.vue';
import AuthViewContainer from '@/components/auth/AuthViewContainer.vue';
import FormInputGroup from '@/components/form/FormInputGroupSignIn.vue';
import EyeOffIcon from '@/components/icons/EyeOffIcon.vue';
import EyeIcon from '@/components/icons/EyeIcon.vue';
import { NOTIFICATION } from '@/entities/Events';
import RouteNames from '@/entities/RouteNames';
import Message, { MessageDuration } from '@/data/notificationsMessages';
import Roles from '@/entities/Roles';
import RouteParams from '@/entities/RouteParams';
import AuthTitle from '@/components/auth/AuthTitle.vue';
import { User } from '@/generated/graphql';
import { isEqual } from 'lodash-es';
import lambdaRequest from '@/helpers/lambdaRequest';

@Component({
	components: {
		AuthTitle,
		UiButton,
		JobBlissLogo,
		AuthFormLink,
		AuthCard,
		FormGroup,
		AuthViewContainer,
		FormInputGroup,
		EyeOffIcon,
		EyeIcon,
	},
})
export default class SignIn extends Vue {
	// @ts-ignore
	given_name: string = '';
	family_name: string = '';
	phone: Number = 0;
	profile: [] = [];

	loading: boolean = false;
	showPassword: boolean = false;
	username: string = '';
	password: string = '';
	errorMessage: string = '';

	routes = RouteNames;

	get claimProfileRouterObject(): RouteParams<{ isClaim: boolean }> {
		return {
			name: RouteNames.RESEND_SIGNUP,
			params: { isClaim: true },
		};
	}

	async submit(): Promise<void> {
		this.loading = true;

		try {
			const userAuth = await auth.signIn(
				this.username.toLowerCase(),
				this.password
			);
			if (
				userAuth &&
				userAuth.challengeName === 'NEW_PASSWORD_REQUIRED'
			) {
				AmplifyEventBus.$emit('authState', 'acceptInvitation');
			}

			const user = await this._getUser(userAuth.username);
			if (user) {
				const userRole = user.role;
				const isAdmin = userRole === Roles.ADMIN;
				user.role === Roles.CONTRACTOR
					? user.profile_completed
						? AmplifyEventBus.$emit('authState', 'projectContrators')
						: AmplifyEventBus.$emit('authState', 'onBoarding')
					: isAdmin ? AmplifyEventBus.$emit('authState', 'signedInadminTalentDirectory') : AmplifyEventBus.$emit('authState', 'signedInTalentDirectory');
			}
			// this.updateProfileBasic(user);
		} catch (e) {
			// this.$eventBus.emit(
			//   NOTIFICATION,
			//   Message.errorMessage(e.message, MessageDuration.LONG),
			// );
			this.errorMessage = 'Your email and password do not match';
		} finally {
			this.loading = false;
			this.password = '';
		}
	}

	contractorPageRoute(purposeOfSignUp) {
		return {
			name: RouteNames.SIGNUP,
			params: {
				id: purposeOfSignUp,
			},
		};
	}


	async _getUser(id: string): Promise<User> {
		const response = await this.$apollo.query({
			query: GET_USER,
			variables: { id },
		});

		return response.data.user_by_pk;
	}

	get getPasswordInputType(): string {
		if (!this.showPassword) {
			return 'password';
		}
		return 'text';
	}

	togglePasswordVisibility(): void {
		this.showPassword = !this.showPassword;
	}
	async updateProfileBasic(user: User): Promise<void> {
		if (user) {
			//@ts-ignore
			this.family_name = user.family_name;
			//@ts-ignore
			//this.phone= user.family_name
			//@ts-ignore
			this.profile = user.profile;
			//@ts-ignore
			this.given_name = user.given_name;

			const oldUserData = {
				user: {
					given_name: this.given_name,
					family_name: this.family_name,
					//phone:this.phone
				},
				user_profile: {
					country: '',
					state: '',
					city: '',
					job_title: '',
					company_name: '',
					postal_code: '',
				},
			};

			const updatedUserData = {
				user: {
					given_name: this.given_name,
					family_name: this.family_name,
					//phone: Number(this.phone) || undefined,
				},
				user_profile: {
					job_title: '.',
					country: '',
					state: '',
					city: '',
				},
			};

			const userDataChanged = !isEqual(oldUserData, updatedUserData);

			try {
				if (userDataChanged) {
					await lambdaRequest({
						lambdaName: 'updateUserPrimaryData',
						method: 'put',
						requestData: updatedUserData,
					});

					//this.refetch();
				}
			} catch (error) {
				this.$eventBus.emit(
					NOTIFICATION,
					Message.errorMessage(error.message)
				);
			} finally {
				//this.processing = false;
			}
		}
	}
}
